
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pintar-shop",
      function () {
        return require("private-next-pages/pintar-shop.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pintar-shop"])
      });
    }
  